import { useReactiveVar } from '@apollo/client';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import type React from 'react';
import CollectionsDrawer from 'src/HomePage/DrawerAndPushedContents/RightSideDrawer/CollectionsDrawer/CollectionsDrawer';
import styles from 'src/HomePage/DrawerAndPushedContents/RightSideDrawer/RightSideDrawerStyles';
import useDrawerResize from 'src/hooks/useDrawerResize';
import viewStateVar from 'src/store/viewState';

const RightSideDrawer: React.FC = () => {
  const viewState = useReactiveVar(viewStateVar);
  const classes = styles();
  const { resizeHandleProps } = useDrawerResize({
    side: 'right',
    min: 320,
    max: 480,
    defaultWidth: 320,
  });

  const activeWidth = viewState.showRightSidebar ? viewState.rightDrawerWidth : viewState.minRightDrawerWidth;

  const openDrawer = (): void => {
    const opening = !viewState.showRightSidebar;
    viewStateVar({
      ...viewStateVar(),
      showRightSidebar: opening,
      ...(opening
        ? {
            rightDrawerWidth:
              viewState.rightDrawerWidth <= viewState.minRightDrawerWidth
                ? viewState.defaultRightDrawerWidth
                : viewState.rightDrawerWidth,
            showHorizontal: false,
            showLeftSidebar: false,
          }
        : {}),
    });
  };

  return (
    <Drawer
      open={viewState.showRightSidebar}
      style={{ width: activeWidth }}
      anchor="right"
      className={classes.drawer}
      variant="permanent"
      PaperProps={{ style: { width: activeWidth } }}
    >
      {viewState.showRightSidebar && <div className={classes.resizeHandle} {...resizeHandleProps} />}
      {viewState.showRightSidebar && <CollectionsDrawer />}
      <IconButton
        id="cyp-drawer-icon"
        className={clsx(classes.drawerIcon, viewState.showRightSidebar && classes.drawerIconOpen)}
        onClick={openDrawer}
        style={{
          right: activeWidth - 22,
        }}
        size="small"
      >
        <PlaylistPlayIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Drawer>
  );
};

export default RightSideDrawer;
